<template>
  <div class="th-custom-clinro-history">
    <div
      v-translate:_formattedInformation="{
        key: instructionScreen.id,
        val: lang,
        html: instructionScreen.formattedInformation
      }"
      v-html="instructionScreen.formattedInformation"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    instructionScreen: {
      type: Object
    },
    lang: {
      type: String
    }
  }
};
</script>

<style lang="scss">
.th-custom-clinro-history {
  .main-wrapper {
    color: #000000;
    padding: 30px;
  }
  .p-header {
    font-family: "Times New Roman", Times, serif;
    font-size: 14.5;
    font-style: italic;
    font-weight: bold;
    padding-bottom: 12px;
    margin: 0;
  }
  .instruction {
    font-family: "Times New Roman", Times, serif;
    font-size: 14.5;
    margin: 0;
    font-weight: normal;
    font-style: italic;
    text-align: left;
  }
  .question-heading {
    font-family: "Times New Roman", Times, serif;
    font-size: 14px;
    margin: 0;
    font-weight: bold;
    color: #000000;
  }
  .answer-heading {
    font-family: "Times New Roman", Times, serif;
    font-size: 12px;
    margin: 0;
    font-weight: bold;
    color: #000000;
  }
  .qu-text-normal {
    font-family: "Times New Roman", Times, serif;
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    margin: 0;
    color: #000000;
  }

  .qu-text-italic-bold {
    font-family: "Times New Roman", Times, serif;
    font-size: 12px;
    font-style: italic;
    font-weight: bold;
    padding-bottom: 12px;
    margin: 0;
  }

  .qu-text-italic-regular {
    font-family: "Times New Roman", Times, serif;
    font-size: 16px;
    margin: 0;
  }
  .font-italic {
    font-style: italic;
  }
  .ideation-text {
    font-style: italic;
    font-size: 13px;
    font-family: "Times New Roman", Times, serif;
    margin: 0;
  }

  .ideation-text-normal {
    font-family: "Times New Roman", Times, serif;
    font-size: 13.5px;
    margin: 0;
    color: #000000;
  }
  .ideation-text-italic-bold {
    font-family: "Times New Roman", Times, serif;
    font-size: 14px;
    font-style: italic;
    font-weight: bold;
    margin: 0;
    color: #000000;
  }
  .ideation-text-italic-bold.pl-19 {
    padding-left: 21px;
  }
  .border-top {
    border-top: 1px solid #000000 !important;
  }
  .small-text {
    font-size: 10.5px;
    font-style: italic;
  }
  .ideation-text-normal-bold {
    font-family: "Times New Roman", Times, serif;
    font-size: 14px;
    font-weight: bold;
    margin: 0;
    color: #000000;
  }

  /* CSS for CSSR First Page */
  .pageTitle {
    font-size: 36px;
    text-align: center;
    font-family: Arial;
    font-weight: bold;
    margin: 0;
    line-height: 2;
  }
  .pageSubtitle {
    font-size: 26px;
    text-align: center;
    font-family: "Times New Roman", Times, serif;
    font-weight: normal;
    margin: 0;
    line-height: 2;
  }
  .authorName {
    font-size: 28px;
    text-align: center;
    font-family: "Times New Roman", Times, serif;
    font-weight: bold;
    font-style: italic;
    margin: 0;
  }
  .page-content {
    font-size: 24px;
    font-family: "Gill Sans MT";
    font-weight: normal;
    font-style: italic;
    margin: 0;
    line-height: 120%;
  }
  .page-content-normal {
    font-size: 24px;
    font-family: "Gill Sans MT";
    font-weight: normal;
    font-style: normal;
    text-align: center;
    margin: 0;
    line-height: 2;
  }
  .page-content-title {
    font-size: 24px;
    font-family: "Gill Sans MT";
    text-align: center;
    font-weight: normal;
    font-style: italic;
    margin: 0;
    line-height: 2;
  }
  .page-content-bold {
    font-size: 24px;
    text-align: center;
    font-family: "Gill Sans MT";
    font-weight: bold;
    font-style: italic;
    text-decoration: underline;
    margin: 0;
  }
}
</style>
